import type { TFunction } from 'i18next';
import type { RowAction } from '../../components/ui/RowActions';
import type { Order, OrderStatus } from '../../types/Order';
import { BOARD_STATUSES } from './config';
import type { PaymentChange } from './orderApi';

export interface OrderMenuHandlers {
    onPay: (order: Order, p: PaymentChange) => void;
    onMove: (order: Order, to: OrderStatus) => void;
    onCancel: (order: Order) => void;
}

/** The overflow menu of a ticket or table row: open, paid, "Move to ..." (any column), cancel. */
export const orderMenu = (t: TFunction, order: Order, h: OrderMenuHandlers): RowAction[] => [
    { id: 'details', label: t('menu.details'), to: `/orders/${order.id}` },
    ...(order.paymentStatus === 'unpaid'
        ? [
              { id: 'cash', label: t('menu.paidCash'), onSelect: () => h.onPay(order, { status: 'paid', method: 'cash' }) },
              { id: 'card', label: t('menu.paidCard'), onSelect: () => h.onPay(order, { status: 'paid', method: 'card' }) },
          ]
        : [{ id: 'unpaid', label: t('menu.unpaid'), onSelect: () => h.onPay(order, { status: 'unpaid' }) }]),
    ...BOARD_STATUSES.filter((s) => s !== order.status).map((s, i) => ({
        id: `move-${s}`,
        label: t('menu.moveTo', { status: t(`common:status.${s}`) }),
        separated: i === 0,
        onSelect: () => h.onMove(order, s),
    })),
    { id: 'cancel', label: t('menu.cancel'), tone: 'danger' as const, separated: true, onSelect: () => h.onCancel(order) },
];
